import React from 'react'

import { CurrentUser } from 'generated/types'

import DropdownForConsultants from './ForConsultants'
import DropdownForCustomers from './ForCustomers'

const ProjectsDropdown: React.FC<ProjectsDropdownGenericProps> = (props) => {
  const { currentUser } = props

  if (!currentUser.isSignedIn) { return null }

  const DropDown = currentUser.isConsultant ? DropdownForConsultants : DropdownForCustomers

  return <DropDown {...props} />
}

type ProjectsDropdownGenericProps = React.ComponentProps<typeof DropdownForCustomers> &
  React.ComponentProps<typeof DropdownForConsultants> &
  { currentUser: CurrentUser }

export default ProjectsDropdown
